module.exports = __webpack_public_path__ + "img/fullscreen.1dd4b79c.svg";